import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-policy-en',
  templateUrl: './cookie-policy-en.component.html',
  styleUrls: ['./cookie-policy-en.component.scss']
})
export class CookiePolicyEnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
